/* ============================================================
   VELUR — storefront cart behaviour
   AJAX add-to-cart + live header cart count + tiny toast.
   Falls back to normal form POST if anything fails.
   ============================================================ */
(function () {
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }

  function setCount(n){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = n;
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden','');
    });
  }

  function toast(msg){
    var t = document.getElementById('vtoast');
    if(!t){ t = document.createElement('div'); t.id='vtoast'; document.body.appendChild(t);
      t.style.cssText='position:fixed;left:50%;bottom:26px;transform:translateX(-50%) translateY(20px);z-index:10000;background:#1c1b18;color:#ffffff;padding:14px 26px;font:600 12px/1 "Gotham","Montserrat",sans-serif;letter-spacing:.18em;text-transform:uppercase;opacity:0;transition:opacity .4s,transform .4s;'; }
    t.textContent = msg;
    requestAnimationFrame(function(){ t.style.opacity='1'; t.style.transform='translateX(-50%) translateY(0)'; });
    clearTimeout(t._h); t._h = setTimeout(function(){ t.style.opacity='0'; t.style.transform='translateX(-50%) translateY(20px)'; }, 2200);
  }

  ready(function () {
    // sync the header count on load
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){ setCount(c.item_count); })
      .catch(function(){});

    // AJAX add-to-cart
    var form = document.getElementById('ProductForm');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // let it POST normally
      e.preventDefault();
      var btn = form.querySelector('[data-add]');
      var label = form.querySelector('[data-add-text]');
      var prev = label ? label.textContent : '';
      if (btn) btn.disabled = true;
      if (label) label.textContent = 'Adding…';

      var idEl = form.querySelector('[name="id"]') || form.querySelector('[data-variant-id]') || form.querySelector('[data-variant-select]');
      var qtyEl = form.querySelector('[name="quantity"]');
      if (!idEl || !idEl.value) {
        if (btn) btn.disabled = false;
        if (label) label.textContent = prev;
        form.submit();
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: idEl.value, quantity: qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1 })
      }).then(function (r) { return r.json().then(function(d){ return { ok:r.ok, d:d }; }); })
        .then(function (res) {
          if (btn) btn.disabled = false;
          if (label) label.textContent = prev;
          if (res.ok) {
            return fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
              setCount(c.item_count);
              /* a product page with its own "View Cart" button keeps the customer where they are (her word,
                 2026-10-12); the basket is refreshed quietly and opens when they ask */
              var stay = !!document.querySelector('[data-viewcart]');
              if (window.VelurDrawer) { window.VelurDrawer.refresh(!stay); } else if (!stay) { toast('Added to cart'); }
              try { document.dispatchEvent(new CustomEvent('velur:added', { detail: c })); } catch (err) {}
            });
          } else {
            toast((res.d && res.d.description) || 'Could not add');
          }
        }).catch(function () {
          if (btn) btn.disabled = false;
          if (label) label.textContent = prev;
          form.submit(); // fallback
        });
    });
  });
})();
